module.exports = __webpack_public_path__ + "img/fo.7dc70ebf.svg";